/**
 * Basic Region model.
 *
 */

class RegionModel {
  constructor(xbaseid, name, latitude, longitude, country, id, distance, timezoneOffset) {
    this.xbaseid = xbaseid;
    this.id = id;
    this.name = name;
    this.latitude = latitude;
    this.longitude = longitude;
    this.country = country;
    this.distance = distance;
    this.timezoneOffset = timezoneOffset;
  }
}

export default RegionModel;
